import { SxProps, Theme } from "@mui/material";

export const MprcMergeSx = (...sxProps: SxProps<Theme>[]): SxProps<Theme> => {
    return sxProps.reduce((prev, currentValue) => {
        return [
            ...(Array.isArray(prev) ? prev : [prev]),
            ...(Array.isArray(currentValue) ? currentValue : [currentValue]),
        ];
    }, [] as SxProps<Theme>);
};
